import Vue from "vue";
import Vuex from "vuex";
import API from "../api";

const _ = require("lodash");

Vue.use(Vuex);

async function HandleError(callback) {
	try {
		await callback();
	} catch (e) {
		throw e.response.data;
	}
}
const Instance = {
	namespaced: true,
	state: {
		dataList: {	// paginatioin
			total: 0,
			list: []
		},
		ruleForm: {}
	},
	mutations: {},
	actions: {
		async getSchoolList({ state }, query) {
			await HandleError(async () => {
				state.dataList = (await API.GetSchoolList(query)).data;
			});
		},
		async createSchool({ state }, { query, data }) {
			await HandleError(async () => {
				state.dataList = (await API.createSchool(query, data)).data;
			});
		},
		async updateSchool({ state }, { query, data }) {
			await HandleError(async () => {
				state.dataList = (await API.updateSchool(query, data)).data;
			});
		},
		async deleteSchool({ state }, { query, id }) {
			await HandleError(async () => {
				state.dataList = (await API.deleteSchool(query, id)).data;
			});
		}
	}
};

export default Instance;